module.exports = __webpack_public_path__ + "img/healthy_page05_img2.30bf1e4b.png";